module.exports = __webpack_public_path__ + "static/img/bg6.10af74a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg6.jpg
// module id = 519
// module chunks = 2